module.exports = __webpack_public_path__ + "img/2023-01-09d_3.d77c5f35.jpg";